import { render, staticRenderFns } from "./a-switch-circle.vue?vue&type=template&id=f8ee6cae&"
import script from "./a-switch-circle.vue?vue&type=script&lang=js&"
export * from "./a-switch-circle.vue?vue&type=script&lang=js&"
import style0 from "./a-switch-circle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports